        <template>
  <div
      >
    <b-row
          >
                                    <b-col
                                                                                                >
                            <documents-list />            </b-col>
                            </b-row>
  </div>
</template>
<script>
/* eslint-disable */
// prettier-ignore
import {
  BRow,
  BCol,
} from 'bootstrap-vue'


                                      import DocumentsList from '@core/components/news-and-documents/documents/documents-list/DocumentsList.vue'
                            
export default {
  components: {
    BRow,
    BCol,

                                                          DocumentsList,
                                          },
  setup() {
    
      },
}
</script>
    